import axios from "axios";

const spi = axios.create({
    baseURL: "http://192.168.0.9:30080/spi/RoladaTreeViewService/rolada",
    timeout: 1000 * 10
});

export default spi;